import { render, staticRenderFns } from "./resourceTab.vue?vue&type=template&id=4e3bf08b&scoped=true&"
import script from "./resourceTab.vue?vue&type=script&lang=js&"
export * from "./resourceTab.vue?vue&type=script&lang=js&"
import style0 from "./resourceTab.vue?vue&type=style&index=0&id=4e3bf08b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3bf08b",
  null
  
)

export default component.exports